import { render } from "./Prop65.vue?vue&type=template&id=417c5c46&scoped=true"
import script from "./Prop65.vue?vue&type=script&lang=js"
export * from "./Prop65.vue?vue&type=script&lang=js"

import "./Prop65.vue?vue&type=style&index=0&id=417c5c46&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417c5c46"]])

export default __exports__